import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { DATE_FORMAT } from "config/constants";
import ShopHeaderMini from "components/elements/main/ShopHeaderMini";
import {
    getLocalDate,
    getTimeSlot,
    getImage,
    isShopSiteAndSubdomain,
    isMarketPlace,
    getURI, openUpiApp,
    isMobileApp, openURL
} from "helpers/utils";
import {
    Avatar, Box, Button, Card, Container, IconButton, Typography, Grid, CardHeader, CardContent, Divider
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PaymentIcon from '@mui/icons-material/Payment';
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CustomSectionCreator from "components/CustomSectionCreator";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "actions";
import * as ActionsBase from "actions/core/core.actions";
import ImagesDownload from "components/elements/main/ImagesDownload";
import * as ActionTypes from "constants/ActionTypes";
import {Notification} from "components/Atoms";
import ButtonComponent from "components/Button";

const OrderSuccess = (props) => {

  const { location, wholesale, match, bootupInfo } = props;

  const {
    order_id, _id, items, shipping, symbol, total_price, total_shipping, shippingoption, total_order, total_tax, created_at, order_type, delivery_date, delivery_time, status,
  } = location.state || {};

    const {
        serviceError, reqStatus, isLoading,
        shopinfo, userUpdateOrderStatus, history
    } = props;

    const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);

    const [copySuccess, setCopySuccess] = useState('Copy');
    const [showQRPopup, setShowQRPopup] = useState(false);


    const copyToClipBoard = async copyMe => {
        try {
            await navigator.clipboard.writeText(copyMe);
            setCopySuccess('Copied!');
        } catch (err) {
            setCopySuccess('Failed to copy!');
        }
    };

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };


    useEffect(() => {
        if (serviceError && reqStatus) {
            const feedback = {
                title: "Something went wrong!",
                description: serviceError.statusText,
            };
            sendNotification("error", feedback);
        }
        switch (reqStatus) {
            case ActionTypes.USER_UPDATE_ORDER_STATUS_SUCCESS:
                history.push(getURI(process.env.REACT_APP_TYPE, "shop_orders", shopinfo.id, "", ""));
                break;
            default:
                break;
        }
    }, [serviceError, reqStatus]);

    const updateOrder = () => {
        userUpdateOrderStatus({ order_id: _id, status: "paid", message: "" });
        setShowQRPopup(false); // Auto-close QR popup when payment confirmed
    };

    const renderOrderInformation = () => (
    <Box>
          <CustomSectionCreator icon={<ShoppingCartRoundedIcon />} title={"Order Confirmation: " + order_id}>
          </CustomSectionCreator>
    </Box>
  );

    {/*
    const triggerUPIPayment = () => {

        if (shopinfo.paymentupi) {

            const upiId = shopinfo.paymentupi;
            const amount = total_order;
            const name = shopinfo.title || "Merchant";
            const txnId = `T${Date.now()}`;
            const note = `Order No: ${order_id}`;

            openURL(`upi://pay?pa=${upiId}&pn=${encodeURIComponent(name)}&tid=${txnId}&am=${amount}&tn=${encodeURIComponent(note)}&cu=INR`);

        } else {
            // Show QR code popup on desktop
            setShowQRPopup(true);
        }
    };
    */}

    const triggerUPIPayment = (app) => {
        if (shopinfo.paymentupi) {
            const upiId = shopinfo.paymentupi;
            const amount = total_order;
            const name = shopinfo.title || "Merchant";
            const txnId = `T${Date.now()}`;
            const note = `Order No: ${order_id}`;

            const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(name)}&tid=${txnId}&am=${amount}&tn=${encodeURIComponent(note)}&cu=INR`;

            openURL(upiUrl, (errorMessage) => {
                // Notify user from the main component (use Notification or state)
                Notification.error({
                    message: "Payment App Error",
                    description: errorMessage,
                });
            });
        } else {
            // Show QR code popup on desktop
            setShowQRPopup(true);
        }
    };


    const renderPendingPaymentInformation = () => (
        <Card variant="outlined" sx={{ mb: 3 }}>
            <CardHeader 
                avatar={<PaymentIcon sx={{ color: 'primary.main' }} />} 
                title="Complete Your Payment" 
                titleTypographyProps={{ fontWeight: 600 }} 
                sx={{ bgcolor: 'grey.200' }} 
            />
            <CardContent>
                {shopinfo.paymentoption && shopinfo.paymentoption.includes("upibased") ? (
                    <Box>
                         <Typography variant="subtitle2" gutterBottom>
                            Pay <b>{symbol}{total_order}</b> via UPI to:
                        </Typography>
                         <Box display="flex" alignItems="center" bgcolor="grey.100" p={1} borderRadius={1} mb={2}>
                            <Typography variant="body2" fontWeight={600} sx={{ flexGrow: 1 }}>{shopinfo.paymentupi}</Typography>
                            <Button size="small" onClick={() => copyToClipBoard(shopinfo.paymentupi)}>{copySuccess}</Button>
                         </Box>

                        {/* Pay Now Buttons */}
                        <Grid container spacing={1}>
                             <Grid item xs={12}>
                                <Button fullWidth variant="contained" color="primary" onClick={() => openUpiApp("gpay", shopinfo.paymentupi, shopinfo.title, order_id, order_id, total_order)}>Google Pay</Button>
                             </Grid>
                             <Grid item xs={12}>
                                <Button fullWidth variant="contained" color="primary" onClick={() => openUpiApp("phonepe", shopinfo.paymentupi, shopinfo.title, order_id, order_id, total_order)}>PhonePe</Button>
                             </Grid>
                             <Grid item xs={12}>
                                <Button fullWidth variant="contained" color="primary" onClick={() => openUpiApp("paytm", shopinfo.paymentupi, shopinfo.title, order_id, order_id, total_order)}>PayTM</Button>
                             </Grid>
                             <Grid item xs={12}>
                                <Button fullWidth variant="outlined" onClick={() => openUpiApp("default", shopinfo.paymentupi, shopinfo.title, order_id, order_id, total_order)}>Other UPI Apps</Button>
                             </Grid>
                        </Grid>
                        
                        <Divider sx={{ my: 2 }} />
                        
                        <Typography variant="body2" color="text.secondary" gutterBottom align="center">
                            After payment, click below to confirm.
                        </Typography>

                        <ButtonComponent
                            variant="contained"
                            type="primary"
                            name="I Have Paid"
                            fullWidth
                            onClick={() => updateOrder()}
                        />

                    </Box>
                ) : (
                     <Box textAlign="center">
                         <Typography variant="h6" gutterBottom>Scan QR to Pay</Typography>
                         <ImagesDownload
                            images={shopinfo.paymentqrcode}
                            message={`Scan to pay ${symbol}${total_order}`}
                            shopqrfilename={shopinfo.title + " order " + order_id}
                        />
                         <Box mt={2}>
                            <ButtonComponent
                                variant="contained"
                                type="primary"
                                name="Confirm Paid"
                                fullWidth
                                onClick={() => updateOrder()}
                            />
                        </Box>
                     </Box>
                )}
            </CardContent>
        </Card>
    );


    const renderPaymentInformation = () => (
        <Box>
            {status === "paymentpending" ? renderPendingPaymentInformation()
                :
                 <Card variant="outlined" sx={{ mb: 3 }}>
                    <CardHeader 
                        avatar={<PaymentIcon sx={{ color: 'success.main' }} />} 
                        title="Payment Status" 
                        titleTypographyProps={{ fontWeight: 600 }} 
                        sx={{ bgcolor: 'success.light', color: 'success.contrastText' }} 
                    />
                    <CardContent>
                        <Typography variant="h6" color="success.main" align="center">
                            <PaymentIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                            Payment: Later
                        </Typography>
                    </CardContent>
                </Card>
            }
        </Box>
    );

    const renderOrderItems = () => (
        <Card variant="outlined" sx={{ mb: 3 }}>
            <CardHeader 
                avatar={<ShoppingCartIcon sx={{ color: 'primary.main' }} />} 
                title="Order Items" 
                titleTypographyProps={{ fontWeight: 600 }} 
                sx={{ bgcolor: 'grey.200' }} 
            />
            <CardContent>
                {items && items.map((item, index) => (
                    <React.Fragment key={index}>
                        <Box display="flex" alignItems="center" my={1.5}>
                            <Avatar variant="rounded" src={getImage(item.product.images)} sx={{ width: 60, height: 60, mr: 2 }} />
                            <Box flexGrow={1}>
                                <Typography fontWeight={600}>{item.product.name}</Typography>
                                <Typography variant="body2" color="text.secondary">{item.quantity} x {symbol}{parseFloat(item.seller_price).toFixed(2)}</Typography>
                                {item.product_size && <Typography variant="caption" color="text.secondary">Size: {item.product_size}</Typography>}
                            </Box>
                            <Typography fontWeight={600}>{symbol}{(item.quantity * parseFloat(item.seller_price)).toFixed(2)}</Typography>
                        </Box>
                        {index < items.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
            </CardContent>
        </Card>
    );

    const renderOrderSummary = () => (
        <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.200', borderRadius: 2 }}>
            <Grid container spacing={1} justifyContent="flex-end">
                <Grid item xs={6}><Typography color="text.secondary">Subtotal:</Typography></Grid>
                <Grid item xs={6}><Typography align="right">{symbol}{total_price ? parseFloat(total_price).toFixed(2) : '0.00'}</Typography></Grid>
                
                <Grid item xs={6}><Typography color="text.secondary">Delivery:</Typography></Grid>
                <Grid item xs={6}>
                    <Typography align="right">
                        {shippingoption === "actualcost"
                    ? "To Be Added"
                    : `${symbol}${total_shipping ? parseFloat(total_shipping).toFixed(2) : '0.00'}`
                }
                </Typography></Grid>
                
                <Grid item xs={6}><Typography color="text.secondary">Tax:</Typography></Grid>
                <Grid item xs={6}><Typography align="right">{symbol}{total_tax ? parseFloat(total_tax).toFixed(2) : '0.00'}</Typography></Grid>
                
                <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>
                
                <Grid item xs={6}><Typography variant="h6" fontWeight={700}>Total:</Typography></Grid>
                <Grid item xs={6}><Typography variant="h6" fontWeight={700} align="right">{symbol}{total_order ? parseFloat(total_order).toFixed(2) : '0.00'}</Typography></Grid>
                
                <Grid item xs={12}> {shippingoption === "actualcost" && <Typography variant="caption" color="error">Pending Delivery Charges - Will be added after order confirmation</Typography>}
                </Grid>
            </Grid>
        </Box>
    );

    const renderDeliveryInfo = () => (
        <Card variant="outlined" sx={{ mb: 3 }}>
             <CardHeader 
                avatar={order_type === "delivery" ? <LocalShippingIcon sx={{ color: 'primary.main' }} /> : <StorefrontIcon sx={{ color: 'primary.main' }} />}
                title={order_type === "delivery" ? "Delivery Details" : "Pickup Information"}
                titleTypographyProps={{ fontWeight: 600 }}
                sx={{ bgcolor: 'grey.200' }}
             />
             <CardContent>

                {order_type === "delivery" && shipping ? (
                    <>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>Shipping to</Typography>
                        <Typography fontWeight={600}>{shipping.name}</Typography>
                        <Typography variant="body2">{shipping.address}, {shipping.city}, {shipping.pincode}</Typography>
                        <Typography variant="body2">{shipping.phone}</Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="body2">Pickup from store.</Typography>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>Schedule</Typography>
                        <Typography variant="body2" fontWeight={600} gutterBottom>
                            {getLocalDate(delivery_date, DATE_FORMAT)} | {getTimeSlot(delivery_time)}
                        </Typography>
                    </>
                )}
             </CardContent>
        </Card>
    );

  return (
      <>
          {order_id
              ? (
                  <Container sx={{ py: 3 }}>
                      <Box mb={3} mt={2}>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>
                            Order Placed Successfully!
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Order #{order_id} • Placed on {getLocalDate(created_at, DATE_FORMAT)}
                        </Typography>
                      </Box>

                      <Grid container spacing={3}>
                          <Grid item xs={12} md={8}>
                              {renderOrderItems()}
                              {renderOrderSummary()}
                          </Grid>
                          <Grid item xs={12} md={4}>
                              {renderPaymentInformation()}
                              {renderDeliveryInfo()}
                          </Grid>
                      </Grid>
                  </Container>
              )
              : (
                  <section className="p-0">
                      <div className="container">
                          <div className="row">
                              <div className="col-sm-12">
                                  <div className="error-section">
                                      <h1>404</h1>
                                      <h2>page not found</h2>
                                      <a href="/" className="btn btn-solid">back to home</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
              )
          }

    {showQRPopup && (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
            }}
        >
            <div style={{ background: "#fff", padding: "20px", borderRadius: "8px" }}>
                <Typography variant="h6">Scan QR to Pay</Typography>
                <ImagesDownload
                    images={shopinfo.paymentqrcode}
                    message={`Pay ${symbol}${total_order} using UPI`}
                    shopqrfilename={shopinfo.title + " order " + order_id}
                />
                <Box mt={2}>
                    <ButtonComponent
                        variant="contained"
                        type="primary"
                        name="Close"
                        onClick={() => setShowQRPopup(false)}
                    />
                </Box>
            </div>
        </div>
    )}

      </>

);
};

OrderSuccess.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
};


// Mapping Props and State.
const orderSuccess = connect(
    ({ bootupInfo, userorders }) => ({
        bootupInfo,
        symbol: bootupInfo.symbol,
        shopinfo: bootupInfo.shopinfo,
        reqStatus: userorders.reqStatus,
        isLoading: userorders.isLoading,
        serviceError: userorders.serviceError,
    }),
    (dispatch) => bindActionCreators({ ...Actions, ...ActionsBase }, dispatch),
)(OrderSuccess);

export { orderSuccess as default };

